<script lang="ts" setup>
import { cva, type VariantProps } from 'class-variance-authority'
import { computed } from 'vue'

import { classMerge } from '../utils'

import { StructureTermList, StructureTermItem } from '.'

import type { StructureTermItemType } from '.'

const tagItemVariants = cva('', {
  variants: {
    level: {
      0: 'block py-3 text-heading-sm border-b-[3px] border-b-outline',
      1: 'block pt-3 pb-[6px] pl-4 text-heading-xs',
      2: 'block pt-3 pb-[6px] pl-8 text-heading-2xs'
    }
  }
})

type TagItemProps = VariantProps<typeof tagItemVariants>

const props = withDefaults(defineProps<{
  tagItem: StructureTermItemType,
  level?: TagItemProps['level'],
  twClass?: string
}>(), {
  level: 0,
  twClass: ''
})

const hasChildren = computed(() => {
  return !!(props.tagItem.children && props.tagItem.children.length > 0)
})

const computedLevel = computed(() => {
  const level = props.level ?? 0
  const nextLevel = level + 1
  return nextLevel as 0 | 1 | 2
})
</script>

<template>
  <li :class="{
    'overflow-hidden': level === 0,
    'last-of-type:pb-6': level === 1
  }">
    <template v-if="tagItem.url && tagItem.url.length > 0">
      <a :href="tagItem.url"
         :class="classMerge(tagItemVariants({ level }), twClass)">
        {{ tagItem.name }}
      </a>
    </template>
    <template v-else>
      <span>
        {{ tagItem.name }}
      </span>
    </template>
    <StructureTermList v-if="hasChildren">
      <StructureTermItem v-for="(item, index) in tagItem.children"
                         :key="`tag-item-${index}`"
                         :tag-item="item"
                         :level="computedLevel" />
    </StructureTermList>
  </li>
</template>
